import { Grid, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import PageConfig, { PageContext } from "../../../config";
import { useTranslation } from "react-i18next";

const { CHECKOUT_OPTION_ENUM } = PageConfig;

const PaymentMethodOption = ({ method, selected = false }) => {
  const { t } = useTranslation();
  const { setSelectedPaymentMethod } = useContext(PageContext);

  const selectedCSSClass = selected ? "selected" : "";
  const iconSource = selected ? method.icon.selected : method.icon.default;

  const handleOnClick = (event) => {
    event.preventDefault();
    setSelectedPaymentMethod(method);
  };
  return (
    <Grid
      container
      direction="column"
      className={`method-option ${selectedCSSClass}`}
      onClick={handleOnClick}
    >
      <img src={iconSource} alt="payment-option" className="icon" />
      <Typography className="label">{t(method.label)}</Typography>
    </Grid>
  );
};

const PaymentMethodSelector = () => {
  const { selectedPaymentMethod } = useContext(PageContext);

  return (
    <Grid
      container
      direction="row"
      className="payment-method-selector w-fit-content"
    >
      {Object.values(CHECKOUT_OPTION_ENUM).map(
        (checkoutOption) =>
          checkoutOption.activated && (
            <Grid item key={checkoutOption.id} className="flex-1">
              <PaymentMethodOption
                method={checkoutOption}
                selected={checkoutOption.id === selectedPaymentMethod.id}
              />
            </Grid>
          )
      )}
    </Grid>
  );
};

export default React.memo(PaymentMethodSelector);
